export default __webpack_public_path__ + "static/info-viajes-banner-fdfac8dddf72b2bb2be425c0c41149d6.svg";